/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant, Intent, Popover, PopoverInteractionKind, Position, Tooltip } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { showToast } from "src/libs/useful"
import { __, getID } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILanding, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { IDataContentEditorProps } from "."
import createMeat from "../../utils/createMeat"
import updateHistory from "../../utils/updateHistory"

import makeupIcon from "src/modules/pe-landing-module/assets/img/makeup.svg"

const DataContentEditForm = (props: IDataContentEditorProps): JSX.Element => {
    const isEdit: boolean           = useLandingStore((state: ILandingStore) => state.isEdit )
    const copyData                  = useLandingStore((state: ILandingStore) => state.copyData )
    const onCopy                    = useLandingStore((state: ILandingStore) => state.onCopy )
    const onPaste                   = useLandingStore((state: ILandingStore) => state.onPaste )
    const editMode                  = useLandingConsoleStore((state:ILandingConsoleStore) => state.editMode)
    const currentLanding: ILanding  = useLandingStore((state: ILandingStore) => state.currentLanding )
    const [data, setData]           = useState<any>(components()[ props.data.type ])
    const [i, setI]                 = useState<number>(0)
    useEffect(() => {
        setI(props.section?.data?.findIndex((data) => data.id === props.data.id) || -1) 
        setData(components()[ props.data.type ])
    }, [props.data.id, props.section])
    
    if( !props.section  ) {
        // return <></>
    }
    const onNewAdd = () => {
        useLandingStore.setState({ 
            isAddMeatDrawerOpen: true,
            addMeatDrawerSectionId:props.section?.id || "-1",
            addMeatDrawerMeatId: props.data.id,
        })
    }
    const onShow = () => {
        const historyStep: IHistoryStep = {
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Hide Meat",
        } 
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(section => {
                if(props.section?.id === section.id) {
                    historyStep.prevData = JSON.parse(JSON.stringify(section ))
                    historyStep.data = {
                        ...section,
                        data: section.data.map(data => {
                            if(data.id === props.data.id) {
                                return {
                                    ...data,
                                    isHidden: !data.isHidden,
                                }
                            }
                            return data
                        })
                    }
                    return historyStep.data
                }
                return section
            })
        }
        updateHistory( historyStep, landing )
    }

    const onDuplicate = () => {
        const historyStep: IHistoryStep = {
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Duplicate Meat",
        } 
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(section => {
                if(props.section?.id === section.id) {  
                    const index = section.data.findIndex((d, ii) => d.id === props.data.id ) 
                    historyStep.prevData = JSON.parse(JSON.stringify(section )) 
                    const newData = {
                        ...props.data,
                        id: getID( props.data.type ),
                    }
                    historyStep.data = Object.assign({}, section )
                    historyStep.data.data.splice( index, 0, newData ) 
                    return section  
                }
                return section
            })
        }
        
        console.log( "historyStep:", historyStep )
        
        updateHistory( historyStep, landing ) 
    }

    const onDelete = () => {
        const historyStep: IHistoryStep = {
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Delete Meat",
        } 
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(section => {
                if(props.section?.id === section.id) {
                    historyStep.prevData = JSON.parse(JSON.stringify(section ))
                    section.data.splice(i, 1)
                    historyStep.data = { ...section }
                    return section  
                }
                return section
            })
        }
        updateHistory( historyStep, landing ) 
    }
    const onNewMeat = (evt: any, key: string, n: number = 0) => {
        const historyStep: IHistoryStep = {
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : __("Add new Meat ") + __(components()[key].title),
        } 
        const newLanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((section, i) => {
                if(props.section?.id === section.id) { 
                    const index = section.data.findIndex((d, ii) => d.id === props.data.id )  
                    historyStep.prevData = JSON.parse(JSON.stringify(section ))
                    const newData = createMeat(key, n, {})
                    section.data.splice(index + 1, 0, newData)
                    historyStep.data = { ...section }
                    return section  
                }        
                return section
            })
        }    
        updateHistory( historyStep, newLanding )
    }

    const toUp = () => {
        const historyStep: IHistoryStep = {
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Switch Meats",
        } 
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(section => {
                if(props.section?.id === section.id) {  
                    const index = section.data.findIndex((d, ii) => d.id === props.data.id ) 
                    historyStep.prevData = JSON.parse(JSON.stringify(section ))
                    const newData = section.data.splice( i, 1 )
                    section.data.splice( index - 1, 0, newData[0] )
                    historyStep.data = { ...section }
                    return section  
                }
                return section
            })
        }
        updateHistory( historyStep, landing )
    }
    const toDown = () => {
        const historyStep: IHistoryStep = {
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Switch Meats",
        } 
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(section => {
                if(props.section?.id === section.id) {  
                    const index = section.data.findIndex((d, ii) => d.id === props.data.id ) 
                    historyStep.prevData = JSON.parse(JSON.stringify(section ))
                    const newData = section.data.splice( i, 1 )
                    section.data.splice( index + 1, 0, newData[0] )
                    historyStep.data = { ...section }
                    return section  
                }
                return section
            })
        }
        updateHistory( historyStep, landing )
    }

    const onCopyData = ( data: any ) => {
        onCopy(data)
        showToast({
            message: __("Meat copied")
        })
    }
    const onPasteData = () => { 
        const historyStep: IHistoryStep = {
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : __( "Paste Meats ") ,
        }
        const data: any = onPaste()
        if(data.id && !!data.type && data.jsonData === "Meat") {
            const landing: ILanding = {
                ...currentLanding,
                sections: currentLanding.sections.map( section => {
                    if(props.section?.id === section.id) {   
                        const index = section.data.findIndex((d, ii) => d.id === props.data.id ) 
                        historyStep.prevData = JSON.parse(JSON.stringify(section ))
                        section.data.splice( index + 1, 0, data )
                        historyStep.data = {...section}
                        historyStep.title = __( "Paste Meats ") + __( components()[ data.type ].title )
                        return section  
                    }
                    return section
                })
            }
            updateHistory( historyStep, landing )
        }
        else {
            showToast({
                message: __("Unknown format data")
            })
        }
    }
    const onEdit = () => {
        useLandingStore.setState({ 
            curEditModal: {
                ...props.data, 
                sectionId: props.section?.id, 
                currentEditType: SELECT_TYPE.CONTENT,
            }            
        })
    }
    const onMakeup = () => {
        useLandingStore.setState({ 
            isMakeupDrawerOpen: true,
            makeupType: SELECT_TYPE.CONTENT
        })
    }

    return isEdit
        ?
        <div className="landing-data-edit-form-cont ">
            <div className="landing-data-content-container  ">
                <Tooltip
                    intent={Intent.PRIMARY}
                    position="top-left"
                    content={__("Edit") + ": " + __( data?.title )}
                >
                    <Button 
                        intent={Intent.NONE}  
                        className={`  p-1`} 
                        onClick={ onEdit }
                    > 
                        <img
                            src={ data?.icon }
                            height={ 12 }
                            className="svg-force-contrast landing-icon my-2"
                            style={{
                                height: 12,
                                opacity: 1,
                            }}
                            alt=""
                        />
                    </Button>
                </Tooltip>
                <Tooltip
                    intent={Intent.PRIMARY}
                    position="top-left"
                    content={__(props.data.isHidden ? "Show meat" : "Hide meat")}
                >
                    <Button
                        icon={props.data.isHidden ? "eye-open" : "eye-off"} 
                        intent={Intent.NONE}
                        onClick={ onShow }
                    />
                </Tooltip>
                <Tooltip
                    intent={Intent.PRIMARY}
                    position="top-left"
                    content={__("More")}
                >
                    <Popover 
                        position={Position.TOP}
                        interactionKind={PopoverInteractionKind.CLICK}
                        content={
                            <div className='d-flex flex-column '>
                                <Button 
                                    fill
                                    icon="duplicate" 
                                    className="p-2"  
                                    alignText="left"
                                    variant={ ButtonVariant.MINIMAL }
                                    onClick={ onDuplicate } 
                                > 
                                    {__("Duplicate")}
                                </Button>
                                {/* <Button
                                    fill
                                    intent={Intent.NONE}
                                    icon="plus" 
                                    alignText="left"
                                    variant={ ButtonVariant.MINIMAL }
                                > 
                                    {__("Add Meat after this")}
                                </Button> */}
                                <Button
                                    fill
                                    intent={ Intent.NONE }  
                                    icon="clipboard"   
                                    className="p-2"  
                                    alignText="left"
                                    variant={ ButtonVariant.MINIMAL }
                                    onClick={ () => onCopyData( { ...props.data, jsonData: "Meat", id: getID( props.data.type ) } ) }
                                > 
                                    { __("Copy Meat")} 
                                </Button>
                                <Button
                                    fill
                                    intent={ Intent.NONE }
                                    icon="clipboard"   
                                    className="p-2"  
                                    alignText="left"
                                    variant={ ButtonVariant.MINIMAL }
                                    onClick={ onPasteData }
                                    disabled={ copyData.jsonData !== "Meat" }
                                > 
                                    { __("Paste Meat after this")} 
                                </Button> 
                            </div>
                        } 
                        portalClassName="z-index-130" 
                    >
                        <Button
                            intent={Intent.NONE}
                            icon="more"
                        > 
                        </Button>
                    </Popover> 
                </Tooltip> 
                {
                    i > 0 && 
                        <Tooltip
                            intent={Intent.PRIMARY}
                            position="top-left"
                            content={__("Shift previous")}
                        >
                            <Button  icon="arrow-up" className="p-2" onClick={toUp}/>
                        </Tooltip>
                }
                {
                    i < (props.section?.data?.length || 0) - 2 &&
                        <Tooltip
                            intent={Intent.PRIMARY}
                            position="top-left"
                            content={__("Shift next")}
                        >
                            <Button icon="arrow-down" className="p-2"  onClick={toDown}/>
                        </Tooltip>
                }
                <Tooltip
                    intent={Intent.PRIMARY}
                    position="top-left"
                    content={__("Makeup")}
                >
                    <Button  
                        className={` p-1`}
                        intent={Intent.WARNING}
                        onClick={ onMakeup }
                    > 
                        <img
                            src={ makeupIcon }
                            height={ 12 }
                            className="svg-force-contrast landing-icon my-2"
                            style={{
                                height: 12,
                                opacity: 1,
                            }}
                            alt=""
                        />
                    </Button> 
                </Tooltip>  
                <Tooltip
                    intent={Intent.PRIMARY}
                    position="top-left"
                    content={__("Delete")}
                >
                    <Button icon="trash" className="p-2 ml-1" intent={Intent.DANGER} onClick={onDelete} /> 
                </Tooltip>
            </div>
        </div>
        : 
        <></>
}
export default DataContentEditForm